export default class UserModel {
  id = 0
  ticket = ''
  fullname = ''
  name = ''
  oid = 0
  email = ''
  is_admin = false
  cont_lang_id = 0 // 1 = de, 2 = en
  gui_lang_id = 0
  gui_lang_locale = ''
  validation_cookie = {
    name: '',
    value: '',
  }
  results_per_page = 0
}
